import { lazyValue } from '@proc7ts/primitives';
import { HttpAddressRep } from 'http-header-value/node.js';
import { RequestCapability } from '../../core/request-capability.js';
import { requestUpdate } from '../../core/request-modification.js';
/**
 * @internal
 */
class HttpForwardingCapability extends RequestCapability {
    #trust;
    constructor(trust) {
        super();
        this.#trust = trust;
    }
    for(handler) {
        return ({ request, next }) => {
            const addresses = lazyValue(() => HttpAddressRep.by(request, this.#trust));
            return next(handler, requestUpdate({
                requestAddresses: {
                    get url() {
                        return addresses().url;
                    },
                    get ip() {
                        return addresses().ip;
                    },
                },
            }));
        };
    }
    with(trust) {
        return new HttpForwardingCapability(trust);
    }
}
/**
 * HTTP proxy forwarding capability.
 *
 * Can be used directly, or {@link HttpForwarding.with configured} first.
 */
export const HttpForwarding = /*#__PURE__*/ new HttpForwardingCapability({});
//# sourceMappingURL=http-forwarding.capability.js.map